import axiosInstance from './axiosInstance'

export const getProjectById = (projectId) => {
  return axiosInstance.get(`/projects/${projectId}`)
}

export const getProjectQuoteById = (projectId) => {
  return axiosInstance.get(`/projects/${projectId}/quote`)
}

export const getProjects = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/projects?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const filterProjects = (tab = 'All', page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc', filterFields = [], filterSelections = {}) => {
  return axiosInstance.post('/projects/filter', { tab, page, limit, search, orderByKey, direction, filterFields, filterSelections })
}

export const createProject = (data) => {
  return axiosInstance.post('/projects', data)
}

export const startLegacyProjectImport = (file) => {
  const data = new FormData()
  data.append('file', file)
  return axiosInstance.post('/projects/legacy-import', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const getLegacyProjectImport = (jobId) => {
  return axiosInstance.get(`/projects/legacy-import/${jobId}`)
}

export const updateProject = (projectId, data) => {
  return axiosInstance.put(`/projects/${projectId}`, data)
}

export const deleteProject = (projectId) => {
  return axiosInstance.delete(`/projects/${projectId}`)
}

export const getProjectSalesperson = (projectId) => {
  return axiosInstance.get(`/projects/${projectId}/salesperson`)
}

export const getProjectNoteById = (projectId, noteId) => {
  return axiosInstance.get(`/projects/${projectId}/notes/${noteId}`)
}

export const getProjectNotes = (projectId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/projects/${projectId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createProjectNote = (projectId, data) => {
  return axiosInstance.post(`/projects/${projectId}/notes`, data)
}

export const updateProjectNote = (projectId, noteId, data) => {
  return axiosInstance.put(`/projects/${projectId}/notes/${noteId}`, data)
}

export const deleteProjectNote = (projectId, noteId) => {
  return axiosInstance.delete(`/projects/${projectId}/notes/${noteId}`)
}

export const exportCustomerReport = (data) => {
  return axiosInstance.post('projects/export-customer-report', data)
}

export const exportProjects = (data) => {
  return axiosInstance.post('projects/export', data)
}

export const getMyTasks = (userId) => {
  return axiosInstance.get(`projects/my-tasks/${userId}`)
}

export const uploadProjectInvoicingAttachment = (data, onUploadProgress) => {
  return axiosInstance.post('/projects/invoicing/upload-attachment', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
}

export const deleteProjectInvoicingAttachmentByPath = (data) => {
  return axiosInstance.post('projects/invoicing/delete-attachment-by-path', data)
}
